/** Splits the full Cloudinary URL we receive from the Contentful query,
 *  inserts the proper Cloudinary params then serves the URL to the
 *  image tag so the image loads with the transformations properly applied.
 */
export function convertCloudinaryImage(
  src: string,
  width: number,
  quality: number,
  format?: string,
): any {
  // Support locally hosted images
  if (!src.startsWith('http')) {
    return src;
  }

  const splitSrc = src.split(`/upload`);
  let transformationParams = `/upload/w_${width},q_${quality || `auto`}`;

  if (format) {
    transformationParams += `,f_${format}`;
  }

  splitSrc.splice(1, 0, transformationParams);
  return splitSrc.join(``);
}
